module.exports = __webpack_public_path__ + "img/assistance_img.e29ba439.png";